import { render } from "./Occupation.vue?vue&type=template&id=62f0b30d"
import script from "./Occupation.vue?vue&type=script&lang=js"
export * from "./Occupation.vue?vue&type=script&lang=js"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__